<script setup lang="ts">
import { type FragmentType, graphql, getFragmentData } from '@/gql';
import {
  PartnerHeaderPreview,
  type PartnerHeaderPreviewPartner,
} from '@/features/partners';
import { useGetOrCreateUserChat } from '@/features/chat';
import { useRoutes } from '@glow/shared/lib/routes';

const masterFragment = graphql(/* GraphQL */ `
  fragment MasterHeaderPreview_MasterFragment on Master {
    id
    fullName
    avatarUrl
    rating
    reviewCount
    workPlaces {
      id
      address
    }

    instagramProfile
    telegramProfile
    whatsappProfile
    vkProfile
    youtubeProfile
    personalSite
  }
`);

const props = defineProps<{
  master: FragmentType<typeof masterFragment>;
}>();

const { getUrl } = useRoutes();
const partner = computed<PartnerHeaderPreviewPartner>(() => {
  const master = getFragmentData(masterFragment, props.master);
  return {
    address: master.workPlaces[0].address,
    hasMultipleWorkPlaces: master.workPlaces.length > 1,
    ...master,
  };
});
const { mutate: getOrCreateUserChat, isLoading: isMessageLoading } =
  useGetOrCreateUserChat();

function onMessage() {
  getOrCreateUserChat(
    { userId: partner.value.id },
    {
      onSuccess: (response) => {
        navigateTo(getUrl('chat', { id: response.id }));
      },
    }
  );
}
</script>

<template>
  <PartnerHeaderPreview
    :partner="partner"
    :is-message-loading="isMessageLoading"
    @message="onMessage"
  />
</template>
